// extracted by mini-css-extract-plugin
module.exports = {"modify_message":"ModifyMessage_modify_message__2Ef7g"};